import { AnyAction } from 'redux';
import { App, PhVorbelegungdaten, Produkt, Produktlinie } from '@ps20-frontend/frontend-models';
import { produktReducer } from '@ps20-frontend/reducers';
import { PhActions } from '../phActions';

export const phProduktReducer = function (
  sectionState: Produkt = null,
  action: AnyAction,
): Produkt {
  const newSectionstate = produktReducer(sectionState, action, App.PH);
  switch (action.type) {
    case PhActions.BRUTTOPREISE_CALCULATED:
    case PhActions.PRODUKTLINIEN_CHANGED: {
      const produktlinien: Produktlinie[] = action.payload;
      return { ...newSectionstate, produktlinien };
    }
    case PhActions.PRODUKT_DATEN_VORBELEGT: {
      const relevantVorbelegungdaten: PhVorbelegungdaten = action.payload;
      const newProduktLinien: Produktlinie[] = newSectionstate?.produktlinien?.map(produktlinie => {
        if (produktlinie.zusatzoptionen) {
          produktlinie.zusatzoptionen.forEach(zusatzoption => {
            if (relevantVorbelegungdaten) {
              const vorbelegteZusatzOptionFound =
                relevantVorbelegungdaten.vorvertragBausteinList?.find(
                  vvBstein => vvBstein?.taasTarifrisikoschluessel === zusatzoption?.name,
                );
              if (vorbelegteZusatzOptionFound) {
                zusatzoption.isSelected = true;
              }
              return zusatzoption;
            }
          });
        }
        return produktlinie;
      });

      return { ...newSectionstate, produktlinien: newProduktLinien };
    }
    default:
      return newSectionstate;
  }
};
